import cn from 'classnames';

import CTA from 'react-scale/components/ui/cta';
import styles from 'react-scale/pages/careers/View.module.css';
import { LocationIcon, TimeIcon } from 'react-scale/components/pages/careers/Content';
import { departmentIcons } from 'react-scale/components/pages/careers/Jobs/data';

const JobDescription = ({ position }) => {
  const htmlDecode = content => {
    const e = document.createElement('div');
    e.innerHTML = content;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  };

  const department = position.departments[0].name;
  const location = position.location.name;
  const commitment = htmlDecode(position.content).toLowerCase().includes('part time')
    ? 'Part Time'
    : 'Full Time';
  const positionIcon =
    departmentIcons[department.toLowerCase()] || '/static/images/pages/careers/jobs/business.svg';

  return (
    <div>
      <div className="py-8 grid gap-16 lg:grid-cols-[256px_minmax(900px,_1fr)_100px]">
        <div>
          <div className="sticky flex flex-col justify-center sticky-wrapper" style={{ top: 20 }}>
            <div className="w-full pt-10 lg:bg-white lg:pb-6 lg:mb-8 lg:rounded-lg lg:shadow-lg">
              <div className={cn('mb-8', positionIcon)}>
                <img
                  className="block py-6 mx-auto bg-white rounded-lg shadow-lg lg:bg-transparent w-28 lg:w-auto h-28 lg:py-0 lg:rounded-0 lg:shadow-none"
                  src={positionIcon}
                  alt={`icon for ${department}`}
                />
              </div>
              <p className="text-sm font-medium tracking-widest text-center text-black uppercase">
                {department}
              </p>
            </div>
            <div className="justify-center hidden lg:flex">
              <CTA
                theme="light"
                cta={{
                  buttons: [
                    {
                      href: position.absolute_url,
                      text: 'Apply Now',
                      variant: 'primary'
                    }
                  ]
                }}
              />
            </div>
          </div>
        </div>
        <div className="pb-24">
          <header className="text-center lg:text-left flex flex-col justify-center lg:-mt-4 lg:min-h-[256px]">
            <h1 className="mb-4 text-3xl text-black font-aeonik lg:text-5xl">{position.title}</h1>
            <div className="flex flex-wrap items-center justify-center gap-8 lg:justify-start lg:items-start">
              <div className="flex items-center text-base text-black lg:mb-0 lg:mr-10">
                <LocationIcon className="mr-2 text-black fill-current" style={{ height: 28 }} />
                {location}
              </div>
              {commitment && (
                <div className="flex items-center text-base text-black">
                  <TimeIcon className="mr-2 text-black fill-current" style={{ height: 30 }} />
                  {commitment}
                </div>
              )}
            </div>
            <div className="flex justify-center mt-6 mb-6 lg:hidden">
              <CTA
                theme="light"
                cta={{
                  buttons: [
                    {
                      href: position.absolute_url,
                      text: 'Apply Now',
                      variant: 'primary'
                    }
                  ]
                }}
              />
            </div>
          </header>
          <div className={styles.careersContent}>
            <div className="mb-8 text-base text-gray-900">
              <div dangerouslySetInnerHTML={{ __html: htmlDecode(position.content) }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobDescription;
